module.exports = __webpack_public_path__ + "media/loop.e83e7b30.mp4";